// src/App.js
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import { Box, Spinner, Center } from "@chakra-ui/react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./components/HomePage";
import TopicDetail from "./components/TopicDetail";
import MissionVisionPage from "./components/MissionVisionPage";
import ContactPage from "./components/ContactPage";
import LoginPage from "./components/LoginPage";
import AdminLayout from "./components/AdminLayout";
import AdminDashboard from "./components/admin/AdminDashboard";
import UserManagement from "./components/admin/UserManagement";
import CategoryManagement from "./components/admin/CategoryManagement";
import ContentManagement from "./components/admin/ContentManagement";
import StatisticsDashboard from "./components/admin/StatisticsDashboard";
import AnalyticsTracker from "./components/AnalyticsTracker";
import { ChakraProvider } from "@chakra-ui/react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import theme from "./themev";

const Layout = ({ children }) => {
  const location = useLocation();

  return (
    <Box>
      <Header />
      <Box
        display="flex"
        flex="1"
        overflow="hidden"
        pt={"200px"} // ปรับตามความสูง Header
      >
        <Box
          flex="1"
          ml={{ base: "0", md: "0px" }} // ปรับ ml ใน mobile
          overflowY="auto"
        >
          {children}
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

// Protected Route Component
const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" color="blue.500" />
      </Center>
    );
  }

  if (!isAuthenticated()) {
    // BrowserRouter จะเติม basename="/wc" ให้อัตโนมัติ
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  return children;
};

// Admin Routes Component
const AdminRoutes = () => {
  return (
    <ProtectedRoute requireAdmin={true}>
      <AdminLayout />
    </ProtectedRoute>
  );
};

const App = () => {
  const [currentTheme, setCurrentTheme] = useState(theme);

  return (
    <ChakraProvider theme={currentTheme}>
      <AuthProvider>
        <Router basename="/wc">
          <AnalyticsTracker />
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected Admin Routes */}
            <Route path="/admin" element={<AdminRoutes />}>
              <Route index element={<AdminDashboard />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="categories" element={<CategoryManagement />} />
              <Route path="content" element={<ContentManagement />} />
              <Route path="statistics" element={<StatisticsDashboard />} />
            </Route>
            
            {/* Public Website Routes */}
            <Route 
              path="/*" 
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/home" element={<HomePage />} />
                    <Route path="/topicdetail/:id" element={<TopicDetail />} />
                    <Route path="/missionvision" element={<MissionVisionPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                  </Routes>
                </Layout>
              } 
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ChakraProvider>
  );
};

export default App;
